import { CloseOutlined } from '@ant-design/icons';

import { Layout } from "antd";
import { ToggleableProps } from "./Toggleable";
import { Content, Header } from "antd/es/layout/layout";
import { Section } from './Section';

export function Area(props: { 
  className?: String, 
  children?: React.ReactNode, 
  width?: string, height?: string,
  title?: React.ReactNode,
  toggle?: ToggleableProps,
}) {

  let { width, height, title, toggle } = props;

  if (width === undefined) width = "100%";
  if (height === undefined) height = "100%";
  
  return (
    <div className="mig-wrapper" style={{ width: width, height: height }}>
    <Layout className={"mig-area "+ props.className}>
        { (title || toggle) &&
        <Header >
          <Section >
          <span className="mig-title-2">{title || "&nbsp;" }</span>
          {toggle? <CloseOutlined onClick={toggle.hide} style={{ float: "right", marginRight: "1em" }} /> : null }
          </Section>
        </Header>
        }
        <Content className="mig-content">
          {props.children}
        </Content>
    </Layout>
    </div>
  );
}